import * as types from './actionTypes'

export const initialState = {
  hasMoreUsers: true,
  allUsers: [],
  userById: [],
  operationGroups: [],
}

const Users = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_USERS:
      return {
        ...state,
        allUsers: [...payload],
      }
    case types.FETCH_USER_BY_ID:
      return {
        ...state,
        userById: { ...payload },
      }
    case types.CLEAR_USER_BY_ID:
      return {
        ...state,
        userById: {},
      }
    case types.FETCH_OPERATION_GROUPS:
      return {
        ...state,
        operationGroups: [...payload],
      }

    default:
      return state
  }
}

export default Users
